import React from 'react';
import { Link } from 'react-scroll';

export const Header = ({ data, language = 'bg', onRequestQuote, quoteLabel }) => {
  const title = data?.title || (language === 'bg' ? 'ДВ Пласт' : 'DV Plast');
  const paragraph = data?.paragraph;
  const button = data?.button;

  return (
    <section
      id="header"
      className="relative isolate overflow-hidden bg-ink text-paper min-h-[100svh] grain"
    >
      <div className="absolute inset-0 -z-10">
        <img
          src="/img/intro-bg.webp"
          alt=""
          fetchpriority="high"
          decoding="async"
          className="w-full h-full object-cover"
          width="1920"
          height="1080"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-ink/75 via-ink/55 to-ink/85" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(176,128,48,0.14),transparent_55%)]" />
      </div>

      <div className="max-wrap section-wrap flex flex-col min-h-[100svh] pt-28 sm:pt-32 pb-16 sm:pb-20">
        <div className="flex items-start justify-between gap-4">
          <span className="font-mono text-[0.7rem] tabular-nums tracking-[0.22em] uppercase text-paper/55">
            00 / 04
          </span>
        </div>

        <div className="mt-auto grid grid-cols-12 gap-y-10 gap-x-6 items-end">
          <div className="col-span-12 lg:col-span-9">
            <h1 className="font-serif text-balance tracking-tightest leading-[0.92]"
                style={{ fontSize: 'clamp(3rem, 13vw, 11rem)' }}>
              <span className="block overflow-hidden pb-[0.04em]">
                <span className="block animate-rise" style={{ animationDelay: '80ms' }}>
                  {title}
                </span>
              </span>
            </h1>
          </div>

          <div
            className="col-span-12 lg:col-span-8 xl:col-span-6 lg:col-start-4 xl:col-start-6 animate-reveal"
            style={{ animationDelay: '360ms' }}
          >
            {paragraph && (
              <p className="font-serif italic text-lg sm:text-xl lg:text-2xl leading-[1.45] text-paper/90 text-pretty max-w-xl">
                {paragraph}
              </p>
            )}

            <div className="mt-10 flex flex-wrap items-center gap-x-8 gap-y-4">
              {onRequestQuote && quoteLabel && (
                <button
                  type="button"
                  onClick={onRequestQuote}
                  className="group inline-flex items-center gap-3 bg-paper text-ink px-6 py-3.5 sm:px-7 sm:py-4 rounded-xs hover:bg-brass-soft transition-colors duration-300"
                >
                  <span className="font-sans text-sm tracking-[0.18em] uppercase">
                    {quoteLabel}
                  </span>
                  <svg viewBox="0 0 24 24" fill="none" className="w-5 h-px overflow-visible text-ink transition-transform duration-500 ease-out-quart group-hover:translate-x-1" aria-hidden="true">
                    <path stroke="currentColor" strokeWidth="1" strokeLinecap="square" d="M0 12h24m0 0l-6-6m6 6l-6 6" />
                  </svg>
                </button>
              )}

              {button && (
                <Link
                  to="uslugi"
                  smooth
                  duration={700}
                  offset={-60}
                  className="group inline-flex items-center gap-4 cursor-pointer text-paper"
                >
                  <span className="relative font-sans text-sm tracking-[0.18em] uppercase">
                    {button}
                    <span className="absolute left-0 -bottom-1 w-full h-px bg-paper transition-transform duration-500 ease-out-quart origin-right scale-x-100 group-hover:origin-left" />
                  </span>
                  <svg viewBox="0 0 24 24" fill="none" className="w-10 h-px overflow-visible text-paper transition-transform duration-500 ease-out-quart group-hover:translate-x-2" aria-hidden="true">
                    <path stroke="currentColor" strokeWidth="1" strokeLinecap="square" d="M0 12h24m0 0l-6-6m6 6l-6 6" />
                  </svg>
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>

      <Link
        to="za_nas"
        smooth
        duration={700}
        offset={-40}
        className="hidden sm:block absolute bottom-8 right-8 lg:right-12 xl:right-16 cursor-pointer group"
        aria-label="Scroll"
      >
        <span className="block w-px h-16 bg-paper/40 mx-auto overflow-hidden relative">
          <span className="absolute inset-0 bg-paper translate-y-[-100%] group-hover:translate-y-0 transition-transform duration-700 ease-out-quart" />
        </span>
      </Link>
    </section>
  );
};
